/**
 * Base help sections data structure
 * Each section contains items that can be videos or documents
 * Items with 2+ entries will be rendered as nested accordions
 *
 * Titles are unnumbered here; HelpSectionAccordion prefixes sequential
 * numbers at render time, so hiding or removing a section never leaves
 * a gap in the numbering.
 *
 * Sections with cpOnly: true are only shown to CP texting users.
 *
 * Retired videos are kept commented out in place so they can be
 * re-added later with new Vimeo IDs.
 */

const helpSectionsData = [
  {
    id: 2,
    title: 'Order Follow-Up',
    subtitle: 'Following Up With Your Orders - Fast, Easy, & You Are In Full Control!',
    // Company-specific docs (e.g. Forwarding Host & Manually-Entered
    // Orders) are added via companyOverrides. Sections left with no
    // items are hidden by HelpSectionAccordion.
    items: [
      // Retired:
      // {
      //   type: 'video',
      //   title: 'Overview Video',
      //   vimeoId: '788166654',
      // },
      // {
      //   type: 'video',
      //   title: 'Order Follow-Up Edit Video',
      //   vimeoId: '788166540',
      // },
    ],
  },
  {
    id: 3,
    title: 'Message Templates',
    subtitle: 'Customizing Order Follow-Up Templates',
    items: [
      {
        type: 'video',
        title: 'Overview Video',
        vimeoId: '788166811',
      },
      // Google Doc is company-specific, added via overrides
    ],
  },
  {
    id: 4,
    title: 'Events',
    items: [
      {
        type: 'video',
        title: 'Event Settings',
        vimeoId: '788166355',
      },
      // Retired:
      // {
      //   type: 'video',
      //   title: 'Using the Events Module',
      //   vimeoId: '788166039',
      // },
    ],
  },
  {
    id: 5,
    title: 'Smart Actions',
    items: [
      // Retired:
      // {
      //   type: 'video',
      //   title: 'Setting up Smart Actions',
      //   vimeoId: '799730827',
      // },
      {
        type: 'video',
        title: 'Using Smart Actions in Events',
        vimeoId: '799734218',
      },
    ],
  },
  {
    id: 6,
    title: 'Smart Forms',
    subtitle: 'Setting up & Using',
    cpOnly: true,
    items: [
      {
        type: 'video',
        title: 'Introduction - Smart Forms',
        vimeoId: '1177930754',
      },
      {
        type: 'video',
        title: 'Using Smart Forms',
        vimeoId: '1177930743',
      },
    ],
  },
  {
    id: 7,
    title: 'Contacts',
    subtitle: 'Contact Screen - Managing & Actions for your Contacts!',
    items: [
      // Retired:
      // {
      //   type: 'video',
      //   title: 'Overview Video',
      //   vimeoId: '918213589',
      // },
      // {
      //   type: 'video',
      //   title: 'Filter By - Selecting Contacts',
      //   vimeoId: '918213555',
      // },
      // {
      //   type: 'video',
      //   title: 'Sending Texts and Adding Tag & Campaign',
      //   vimeoId: '918213531',
      // },
      {
        type: 'video',
        title: 'Categories - Adding & Using',
        vimeoId: '1069659750',
      },
      {
        type: 'video',
        title: 'Birthdays - Finding & Using',
        vimeoId: '918213515',
      },
    ],
  },
  // Retired section:
  // {
  //   id: 8,
  //   title: 'Share Codes',
  //   subtitle: 'Sharing and Importing Event Types and Group Types',
  //   items: [
  //     {
  //       type: 'video',
  //       title: 'Share Codes Overview',
  //       vimeoId: '1069660508',
  //     },
  //   ],
  // },
  // CP Voice Calling used to live in a green banner above these
  // sections; demoted to a regular section. cpOnly keeps the old
  // banner's CP-texting-only visibility.
  {
    id: 8,
    cpOnly: true,
    title: 'CP Voice Calling',
    subtitle: 'Learn how to set up and use CP Voice Calling',
    items: [
      {
        type: 'video',
        title: 'CP Voice Calling',
        vimeoId: '1069659657',
      },
    ],
  },
];

export default helpSectionsData;
